import React, { useState, useEffect } from "react";
import "../../css/InputData.css";
import {
  formatField,
  reformatField,
  checkFormat,
  onFocusField,
} from "../../js/format";
import { inputOnEnter } from "../../js/utils";

import { formatCurrency } from "../utils/utils";

export default function InputDataCurrency(props) {
  const [value, setValue] = useState(props.input);
  const [formattedValue, setFormattedValue] = useState(
    props.input.trim() === "" ? "0,00 €" : formatCurrency(props.input)
  );
  const [focused, setFocused] = useState(false);

  let inputRef = React.createRef();

  const getInputSize = () => {
    const sizeClass = {
      0: "input-full",
      1: "input-small",
      2: "input-medium",
      3: "input-large",
      4: "input-super-small",
      5: "input-super-small-2",
      6: "input-full-flex",
    };
    return sizeClass[props.size] || "";
  };

  const handleBlur = (targetValue = value) => {
    let v = targetValue;
    let fv = targetValue;
    if (v.trim() === "") {
      v = "0";
      fv = "0.00 €";
    } else {
      fv = formatCurrency(v);
    }

    if (props.onBlur) {
      props.onBlur(v);
    }
    setValue(v);
    setFormattedValue(fv);
    setFocused(false);
  };

  useEffect(() => {
    if (props.input && !focused) {
      setValue(props.input);
      setFormattedValue(
        props.input.trim() === "" ? "0,00 €" : formatCurrency(props.input)
      );
    }
  }, [props.input]);

  return (
    <div
      className={`input-data ${getInputSize()} ${
        props.extra ? props.extra : ""
      } ${props.error ? "input-error" : ""} ${props.bkg ? "marked-bkg" : ""} ${
        props.inactive ? "inactive-bkg" : ""
      }`}
    >
      <input
        ref={inputRef}
        id={props.id}
        tabIndex={props.tabIndex}
        type={props.type ? props.type : "text"}
        disabled={props.inactive}
        maxLength={props.maxLength}
        onChange={(e) => {
          const v = formatField(
            inputRef.current,
            e.target.value.toUpperCase(),
            "type-float",
            true
          );
          setValue(v);
          setFormattedValue(v);
          if (props.onChange) {
            props.onChange(v);
          }
        }}
        value={formattedValue}
        onBlur={(e) => {
          /*let v = value;
          let fv = value;
          if (v.trim() === "") {
            v = "0";
            fv = "0.00 €";
          } else {
            fv = formatCurrency(v);
          }

          if (props.onBlur) {
            props.onBlur(v);
          }
          setValue(v);
          setFormattedValue(fv);
          setFocused(false);*/
          handleBlur(value);
        }}
        onKeyUp={(e) => {
          inputOnEnter(e);
          if (e.keyCode === 13 && props.onEnter) {
            handleBlur(value);
            props.onEnter(value);
          }
        }}
        onFocus={(e) => {
          /*if (props.considerFocus) {
            e.target.value = onFocusField(
              inputRef.current,
              props.type,
              e.target.value
            );
          }*/
          setFocused(true);
          setFormattedValue(value);
          if (props.onFocus) {
            props.onFocus();
          }
        }}
      ></input>
      {props.icon && (
        <button
          onClick={() => {
            props.onClick();
          }}
        >
          <img src={props.icon} loading="lazy" alt="Icon" />
        </button>
      )}
    </div>
  );
}
